module.exports = __webpack_public_path__ + "img/flags/VC.9434d08.png";